<script lang="ts">
  import EggMark from './EggMark.svelte';
  let { title, sync }: { title: string; sync?: 'idle' | 'syncing' | 'error' } = $props();
</script>

<header class="appbar">
  <EggMark size={22} />
  <span class="title eyebrow">{title}</span>
  {#if sync}
    <span class="dot" class:syncing={sync === 'syncing'} class:error={sync === 'error'}></span>
  {/if}
</header>

<style>
  .appbar {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 18px;
    padding-top: max(14px, env(safe-area-inset-top));
    border-bottom: 1px solid var(--line);
    background: var(--cream);
  }
  .title {
    font-size: 12px;
  }
  .dot {
    margin-left: auto;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--leaf);
  }
  .dot.syncing {
    background: var(--yolk-deep);
  }
  .dot.error {
    background: var(--rooster);
  }
</style>
